import React, { useReducer } from 'react'

import type { IParam } from 'libs/apis'
import type {
  ITicketSelectBranchList,
  ITicketSelectBranchSinglePartial,
} from './model'

import { initialState, reducer, TicketSelectBranchContext } from './context'

export function withTicketSelectBranches(PageComponent: React.FC) {
  return function EnhancedComponent<T>(props: T): JSX.Element {
    const [state, dispatch] = useReducer(reducer, initialState)

    const updateTicketSelectBranches = (
      newBranch: ITicketSelectBranchList[],
      page: number,
      searchParams: IParam & ITicketSelectBranchSinglePartial,
    ): void => {
      dispatch({ type: 'UPDATE', payload: { newBranch, page, searchParams } })
    }

    return (
      <TicketSelectBranchContext.Provider
        value={{ ...state, updateTicketSelectBranches }}
      >
        <PageComponent {...props} />
      </TicketSelectBranchContext.Provider>
    )
  }
}
